import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { Select, Store } from '@ngxs/store';
import { Auth } from 'aws-amplify';
import { Subscription } from 'rxjs';
import { AuthUser, SetFailedAuth, SetShowSpinner } from 'src/app/state-management/actions/app.actions';
import { AppState } from 'src/app/state-management/state/app.state';
import { LocalStorage } from 'src/app/utils/storage';
@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent implements OnInit {
  public signInForm: UntypedFormGroup;
  @Select(AppState.getVersion) version$;
  // public showSpinner: boolean = false;
  @Select(AppState.getFailedAuth) failedAuth$;
  @Select(AppState.getShowSpinner) showSpinner$;
  subscription: Subscription;




  constructor(private store: Store,
    public formBuilder: UntypedFormBuilder,
    private router: Router,
    public toastController: ToastController,
    private storageService: LocalStorage,
    private activatedRoute: ActivatedRoute
  ) {
    Auth.signOut();
  }

  ngOnInit() {
    this.store.dispatch(new SetShowSpinner(false));
    this.signInForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      rememberMe: []
    });
    let userData = this.storageService.getValue('netqSystems-userData');

    if (this.router.getCurrentNavigation().extras && this.router.getCurrentNavigation().extras.state) {
      this.signInForm.patchValue({ email: this.router.getCurrentNavigation().extras.state.email });
      this.signInForm.patchValue({ password: this.router.getCurrentNavigation().extras.state.password });
      if (userData && userData.rememberMe) {
        this.signInForm.patchValue({ rememberMe: userData.rememberMe });
      }
    } else {

      // console.log(this.storageService.getValue('netqSystems-userData'));
      if (userData && userData.rememberMe) {
        this.signInForm.patchValue({ email: userData.email });
        this.signInForm.patchValue({ password: userData.password });
        this.signInForm.patchValue({ rememberMe: userData.rememberMe });
      }
    }

    this.subscription = this.failedAuth$.subscribe(async (value) => {
      if (value) {
        // this.showSpinner = false;
        const toast = await this.toastController.create({
          position: 'top',
          message: 'Email or Password Invalid',
          color: 'warning',
          icon: 'warning-outline',
          animated: true,
          duration: 2000,
          cssClass: 'email-not-registered-toast'
        });
        toast.onDidDismiss().then(data => {
          this.store.dispatch(new SetFailedAuth(false));
        });
        toast.present();
      }
    });


  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  async onSignIn() {
    const { email, password, rememberMe } = this.signInForm.value;
    this.store.dispatch(new AuthUser({ email, password }));
    if (rememberMe) {
      this.storageService.setValue('netqSystems-userData', this.signInForm.value);
    }
  }

  async onForgotPassword() {
    try {
      const resetResult = await Auth.forgotPassword(this.signInForm.get('email').value);
      if (resetResult.CodeDeliveryDetails) {
        this.router.navigate(['forgot-password'], { state: { email: this.signInForm.get('email').value } });
      }
    } catch (err) {
      // console.log(err);
      const toast = await this.toastController.create({
        position: 'top',
        message: 'Email not registered',
        color: 'warning',
        icon: 'warning-outline',
        animated: true,
        duration: 2000,
        cssClass: 'email-not-registered-toast'
      });
      toast.present();
    }
  }

}
